import { Component, type ReactNode } from "react";

import { CaptainDefaultFallback } from "./CaptainDefaultFallback";

type Props = { children: ReactNode; fallback?: ReactNode };
type State = { hasError: boolean };

export class CaptainErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    if (import.meta.env.DEV) console.error("[Captain]", error);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? <CaptainDefaultFallback />;
    }
    return this.props.children;
  }
}
